module.exports = __webpack_public_path__ + "static/img/kjdy09.ad10451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/kjdy09.png
// module id = 132
// module chunks = 0